window.addEventListener('load', function() {

    // Select the original span element
    const originalSpan = document.querySelector('.rc-radio__label');

    // Get the text content and split it based on a regular expression
    const [labelText, priceText] = originalSpan.textContent.trim().split(/(\$[\d.]+)/);

    // Create new span elements for the label and price
    const labelSpan = document.createElement('span');
    const priceSpan = document.createElement('span');

    // Assign the appropriate texts to the new spans
    labelSpan.textContent = labelText.trim();
    priceSpan.textContent = priceText;
    priceSpan.classList.add('one-time__price');
  
    // Clear the original span and append the new spans to it
    originalSpan.textContent = '';
    originalSpan.appendChild(labelSpan);
    originalSpan.appendChild(priceSpan);


    function change_atc() {
        const tryNow_radio = document.getElementById('selling-plan_trynow');
        const tryNow_label = document.querySelector(".trynow_label");
        const oneTime_radio = document.querySelector("#rc-radio1");
        const subscription_radio = document.querySelector("#rc-radio2");
        const oneTime_label = document.querySelector(".onetime-radio");
        const subscription_label = document.querySelector(".subscription-radio");
        const recharge_selling_plans = document.querySelector(".rc-selling-plans");



        function tryNow() {
            // Update Data Values to Product form 
            document.querySelector('.product-form .product-form__submit span').textContent = 'Try for 14 days';
            document.querySelector('input[name="properties[_rechargeOrder]').setAttribute("value", "false");
            document.querySelector('input[name="properties[_tryNow]"]').setAttribute("value", "true");
            document.querySelector('input[name="selling_plan').setAttribute("value", sellingPlanId);
            document.querySelector('#selling-plan_trynow').setAttribute("data-selling-plan", sellingPlanId);

            // Update Radio Selections
            oneTime_radio.checked = false;
            oneTime_label.classList.remove('rc-radio--active');
            subscription_radio.checked = false;
            subscription_label.classList.remove('rc-radio--active');
            tryNow_label.classList.add('trynow--active');
            recharge_selling_plans.style.display = 'none';
            const sellingPlan_tryNow = document.querySelector('.product-form-container [name="selling_plan"]').value;
            setSellingPlan(sellingPlan_tryNow);

        };

        function recharge_oneTime_selected() {
            // Update Data Values to Product form 
            document.querySelector('.product-form .product-form__submit span').textContent = 'Add to cart';
            document.querySelector('input[name="properties[_rechargeOrder]').setAttribute("value", "false");
            document.querySelector('input[name="properties[_tryNow]"]').setAttribute("value", "false");
            document.querySelector('.product-form-container [name="selling_plan"]').value = '';
            document.querySelector('input[name="properties[_tryNow]"]').setAttribute("value", "false");
            // Update Radio Selections
            oneTime_label.classList.add('rc-radio--active');
            tryNow_label.classList.remove('trynow--active');
            setSellingPlan();
        };

        function recharge_subscription_selected() {
            document.querySelector('.product-form .product-form__submit span').textContent = 'Add to cart';
            document.querySelector('input[name="properties[_rechargeOrder]').setAttribute("value", "true");
            document.querySelector('input[name="properties[_tryNow]"]').setAttribute("value", "false");

            setRechargeFeatures();

            // Update Radio Selctions
            subscription_label.classList.add('rc-radio--active');
            recharge_selling_plans.style.display = 'block';
            tryNow_label.classList.remove('trynow--active');


            // Monitor for change of selling plan
            var selling_plan_dropdown = document.querySelector('[name="rc_selling_plan"]');
            document.querySelector('input[name="selling_plan').setAttribute("value", selling_plan_dropdown.value);
            selling_plan_dropdown.addEventListener("change", function() {
            let selling_plan_id = selling_plan_dropdown.value;
            document.querySelector('.product-form-container [name="selling_plan"]').value = selling_plan_id;
            });
            const sellingPlan_subscription = document.querySelector('.product-form-container [name="selling_plan"]').value;
            setSellingPlan(sellingPlan_subscription);
        };

        // Pre-order condition
        if (document.querySelector('.product-form__submit-preorder')) {
            document.querySelector('.product-form .product-form__submit span').textContent = 'Pre-order';
            return;
        }
        if (subscription_radio.checked) {
            recharge_subscription_selected();
        }
        if (oneTime_radio.checked) {
            recharge_oneTime_selected();
        }
        if (document.getElementById('selling-plan_trynow').checked) {
            tryNow();
        }

    }

    if (document.getElementById('rc-radio2')) {
        change_atc();
    }

    // Monitor Radio buttons for Change
    document.addEventListener('change', function(event) {
        // Check if the change event is from one of your radio buttons
        if (event.target.matches('#rc-radio1, #rc-radio2, #selling-plan_trynow')) {
            clearSelections();
            event.target.checked = true;
            change_atc()
        }
    });

    // Function to clear all selections
    function clearSelections() {
        document.querySelector("#rc-radio1").checked = false;
        document.querySelector("#rc-radio2").checked = false;
        document.getElementById('selling-plan_trynow').checked = false;
    }

    // Subscription Details.

    var recharge_info = document.querySelector(
        "label.subscription-radio > span.rc-radio__label > span.rc-radio__subscription"
    );


    var svgString =
        '<svg class=recharge__svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">' +
        '<g clip-path="url(#clip0_2_5080)">' +
        '<mask id="mask0_2_5080" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">' +
        '<path d="M16.1913 0.478638H0.191345V16.4786H16.1913V0.478638Z" fill="white"/>' +
        "</mask>" +
        '<g mask="url(#mask0_2_5080)">' +
        '<path d="M8.19133 11.1452V8.47856M8.19133 5.81189H8.198M14.858 8.47856C14.858 12.1605 11.8732 15.1452 8.19133 15.1452C4.50943 15.1452 1.52466 12.1605 1.52466 8.47856C1.52466 4.79666 4.50943 1.81189 8.19133 1.81189C11.8732 1.81189 14.858 4.79666 14.858 8.47856Z" stroke="#5B6670" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</g>" +
        "</g>" +
        "<defs>" +
        '<clipPath id="clip0_2_5080">' +
        '<rect width="16" height="16" fill="white" transform="translate(0.191345 0.478638)"/>' +
        "</clipPath>" +
        "</defs>" +
        "</svg>";
    recharge_info.insertAdjacentHTML('beforeend', "<span class=recharge__icon>" + svgString + "</span>");
    // *****************************
    // Recharge Subscription Details
    // *****************************

    // Text Content
    function addSubscriptionDetails() {
        kicker_headings = document.querySelectorAll("span.os-kicker-heading");
        installment_headings = document.querySelectorAll("div.klarna-afterpay-installment");
        os_bodys = document.querySelectorAll("div.os-body");
        os_headings = document.querySelectorAll("div.os-heading");
        payment_badges = document.querySelectorAll("span.payment_badges");
        recharge_badge = document.querySelectorAll("span.recharge-icon");
        powerBy_section = document.querySelectorAll("span.os-poweredBy");

        recharge_badge.forEach(function(rc_badge) {
            rc_badge.style.display = "block";
        });
        installment_headings.forEach(function(installment_heading) {
            installment_heading.style.display = "none";
        });
        payment_badges.forEach(function(payment_badge) {
            payment_badge.style.display = "none";
        });
        kicker_headings.forEach(function(kicker_heading) {
            kicker_heading.textContent = "";
            kicker_heading.textContent += "Dermalogica Subscription";
        });
        os_headings.forEach(function(os_heading) {
            os_heading.textContent = "";
            os_heading.textContent += "How subscriptions work";
        });
        os_bodys.forEach(function(os_body) {
            os_body.innerHTML = "";
            os_body.innerHTML +=
                "<p>Products are automatically delivered and charged on your schedule. No obligation, modify or cancel your subscription within 24 hours of the next scheduled shipment date.</p><a href='https://www.dermalogica.com/pages/subscription'><span style='color:#5E93DB'>Learn more</span></a>";
        });
        powerBy_section.forEach(function(powerBy) {
            powerBy.style.display = "flex";

        });
    }


    function rechargeSubscriptionDetails() {
        var onSiteContainer = document.getElementById("os-modal-desktop");
        var onWrapperContainer = document.querySelector(".product__title");
        var rcInfoIcon = document.querySelector("svg.recharge__svg");
        var closeIcon = document.getElementById("os-close");
        var closeIconMobile = document.getElementById("os-close-mobile");

        // Mobile layout: Bottom Modal
        if (window.innerWidth < 600) {
            var osMobile = document.getElementById("os-modal-mobile");
            // When the user clicks the button, open the modal
            rcInfoIcon.addEventListener("click", function() {

                osMobile.style.display = "block";
                addSubscriptionDetails();

            });

            closeIconMobile.onclick = function() {
                osMobile.style.display = "none";
            };

        }

        // Desktop layout: Modal
        if (window.innerWidth >= 600) {
          if (rcInfoIcon){
            rcInfoIcon.addEventListener("click", function() {
                if (!onSiteContainer.classList.contains("recharge")) {
                    setTimeout(function() {
                        onSiteContainer.classList.add("show");
                        onSiteContainer.classList.add("recharge");
                    }, 500);
                }
               
    
                var iconRect = rcInfoIcon.getBoundingClientRect();
                // Calculate the position for the popup box
                var iconTop = iconRect.top  + window.scrollY;
                var iconLeft = iconRect.left + window.scrollX; 
                onSiteContainer.style.position = 'absolute';
                onSiteContainer.style.top = (iconTop - 200) + 'px';// Below the icon
                onSiteContainer.style.left = (iconLeft - 350) +'px';
                addSubscriptionDetails();
               onSiteContainer.style.display = "block";
            });
        }
            closeIcon.addEventListener("click", function(event) {  
                onSiteContainer.style.display = "none";
                onSiteContainer.classList.remove("show");
                onSiteContainer.classList.remove("recharge");
            });


            var rechargeWidget = document.querySelector(".subscription-radio");
            var infoIcon2 = document.querySelector('.info-icon');

            function isClickOutsideElement(element, event) {
                let target = event.target;

                while (target !== null) {
                    if (target === element) {
                        return false; // Click occurred inside the element
                    }
                    target = target.parentNode;
                }

                return true; // Click occurred outside the element
            }

            document.addEventListener("click", function(event) {

                if (onSiteContainer.classList.contains("recharge")) {

                    var isClickDirectlyOnB = event.target === infoIcon2;
                    if (!isClickDirectlyOnB && isClickOutsideElement(onSiteContainer, event)) {

                        onSiteContainer.style.display = "none";
                        onSiteContainer.classList.remove("show");
                        onSiteContainer.classList.remove("recharge");


                    }
                }
            });
        }
    }

    rechargeSubscriptionDetails();
    // Listens to change in variant. 
    document.addEventListener("change", function(event) {
        var target = event.target;
        // Check if the target is an input with the name 'size'
        if (target.tagName === "INPUT" && target.getAttribute("name") === "size") {
            // Use .closest('#variant-radios') for an ID or .closest('.variant-radios') for a class
            var parent = target.closest(".no-js-hidden"); // Adjust selector as needed
            // Proceed if the input is indeed inside the element with ID or class 'variant-radios'
            if (parent) {
                setTimeout(function() {
                    rechargeSubscriptionDetails();
                }, 3000);
            }
        }
    });
});
window.addEventListener('load', function() {
    setTimeout(function() {
        const priceUpdate2 = document.querySelector(".subscription-radio .rc-radio__price")
        if(priceUpdate2){
          priceUpdate2.innerHTML = priceUpdate2.textContent.replace(".00","")
        }
        const priceUpdate = document.querySelector(".one-time__price");
        if(priceUpdate){
            priceUpdate.innerHTML = priceUpdate.textContent.replace(".00","")
          }
    })
})